import { useSnackbar } from 'notistack';
import { ConfirmDialog } from 'components';
import apiService from 'library/api-service';
import { FormattedMessage } from 'react-intl';
import { Dispatch, SetStateAction, useState } from 'react';
import { GridRowSelectionModel } from '@mui/x-data-grid-premium';

type DeleteActivityBoardItemDialogProps = {
  open: boolean;
  activityBoardItemId: number | null;
  handleClose: () => void;
  refresh: () => Promise<void>;
  setRowSelectionModel: Dispatch<SetStateAction<GridRowSelectionModel>>;
};

const DeleteActivityBoardItemDialog = ({
  open,
  activityBoardItemId,
  handleClose,
  refresh,
  setRowSelectionModel,
}: DeleteActivityBoardItemDialogProps) => {
  // other hooks
  const { enqueueSnackbar } = useSnackbar();

  // useState hooks
  const [loading, setLoading] = useState(false);

  // async helper functions
  const handleDelete = async () => {
    if (!activityBoardItemId) return;

    try {
      setLoading(true);

      const response = await apiService.deleteActivityBoardItem(activityBoardItemId);

      if (response.isSuccess) {
        enqueueSnackbar(
          <FormattedMessage
            id="activityManaging.deleteActivityBoardItemCompleted"
            defaultMessage="Seçili aktiviteyi silme işlemi başarıyla tamamlandı."
          />,
          { variant: 'success' }
        );
        handleClose();
        setRowSelectionModel([]);
        refresh();
      }
    } catch {
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmDialog
      open={open}
      title={<FormattedMessage id="activityManaging.deleteActivityBoardItem" defaultMessage="Aktivite Sil" />}
      description={
        <FormattedMessage
          id="activityManaging.deleteActivityBoardItemRepeat"
          defaultMessage="Bu işlem onaylandıktan sonra aktivite veritabanından silinecektir. Silme işlemini onaylıyor musunuz?"
        />
      }
      onClose={handleClose}
      onConfirm={handleDelete}
      loading={loading}
      mobileFullScreen={false}
    />
  );
};

export default DeleteActivityBoardItemDialog;
